module.exports = __webpack_public_path__ + "img/Home-Active.7f070c68.svg";